// Format currency to IDR
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
  }).format(amount)
}

// Format date
export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
}

// Get month year string (YYYY-MM)
export const getMonthYear = (date = new Date()) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  return `${year}-${month}`
}

// Get date range
export const getDateRange = (period) => {
  const now = new Date()
  let startDate = new Date()
  
  switch(period) {
    case 'today':
      startDate.setHours(0, 0, 0, 0)
      break
    case 'week':
      startDate.setDate(now.getDate() - 7)
      break
    case 'month':
      startDate.setMonth(now.getMonth() - 1)
      break
    case 'year':
      startDate.setFullYear(now.getFullYear() - 1)
      break
    default:
      startDate = new Date(now.getFullYear(), now.getMonth(), 1)
  }
  
  return {
    start: startDate.toISOString().split('T')[0],
    end: now.toISOString().split('T')[0],
  }
}

// Export to CSV
export const exportToCSV = (data, filename) => {
  const headers = Object.keys(data[0])
  const csv = [
    headers.join(','),
    ...data.map(row => 
      headers.map(header => JSON.stringify(row[header] || '')).join(',')
    )
  ].join('\n')
  
  const blob = new Blob([csv], { type: 'text/csv' })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  window.URL.revokeObjectURL(url)
}

// Categories with icons
export const CATEGORIES = [
  { value: 'food', label: 'Makanan & Minuman', icon: '🍔' },
  { value: 'transport', label: 'Transportasi', icon: '🚗' },
  { value: 'shopping', label: 'Belanja', icon: '🛒' },
  { value: 'bills', label: 'Tagihan', icon: '💡' },
  { value: 'entertainment', label: 'Hiburan', icon: '🎬' },
  { value: 'health', label: 'Kesehatan', icon: '💊' },
  { value: 'education', label: 'Pendidikan', icon: '🎓' },
  { value: 'others', label: 'Lainnya', icon: '📱' },
]

export const getCategoryIcon = (category) => {
  return CATEGORIES.find(c => c.value === category)?.icon || '📱'
}

export const getCategoryLabel = (category) => {
  return CATEGORIES.find(c => c.value === category)?.label || category
}
